const MVPIcon = (props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M11.993 5c-.372 0-.719.194-.917.51L7.53 11.357 3.24 7.912a1.08 1.08 0 0 0-1.501.145c-.21.243-.285.583-.21.886l2.132 9.244c.111.473.545.813 1.041.813h14.595c.496 0 .93-.34 1.041-.813l2.133-9.244c.137-.558-.223-1.116-.806-1.25-.322-.073-.657 0-.917.219l-4.29 3.445L12.91 5.51a1.056 1.056 0 0 0-.918-.51Z" />
    </svg>
);

export default MVPIcon;
